import { Upload, Trash2 } from "lucide-react";
import { resolveMediaUrl } from "../../../lib/api";

export const SeoVideoUpload = ({ videoUrl, uploading, onUpload, onRemove }) => (
  <div className="space-y-3">
    <h4 className="font-semibold text-sm">Video del servicio</h4>
    <p className="text-xs text-muted-foreground">
      Se muestra debajo de "Lo que incluye este servicio" en la página pública. Formatos mp4/mov/webm, máx. 50MB.
    </p>
    <div className="flex items-center gap-3 flex-wrap">
      {videoUrl && (
        <video
          data-testid="seo-video-preview"
          src={resolveMediaUrl(videoUrl)}
          controls
          className="h-24 w-40 object-cover rounded bg-black"
        />
      )}
      <label data-testid="seo-video-upload-label" className="flex items-center gap-2 border rounded px-3 py-2 text-xs cursor-pointer hover:bg-secondary/50">
        <Upload size={14} /> {uploading ? "Subiendo..." : videoUrl ? "Cambiar video" : "Subir video"}
        <input
          data-testid="seo-video-upload-input"
          type="file"
          accept="video/mp4,video/quicktime,video/webm"
          className="hidden"
          onChange={onUpload}
          disabled={uploading}
        />
      </label>
      {videoUrl && (
        <button
          type="button"
          data-testid="seo-video-remove-button"
          onClick={onRemove}
          className="flex items-center gap-1 text-xs text-red-400 hover:text-red-300 border border-red-400/30 rounded px-3 py-2"
        >
          <Trash2 size={14} /> Eliminar video
        </button>
      )}
    </div>
  </div>
);
